export default {
  name: "App",

  provide() {
    return {
      app: this
    };
  },

  data() {
    return {
      path: "",
      state: ""
    };
  },

  created() {
    // umd mode 在I18n 出現奇怪的錯誤, 所以直接在這裡引入
    if (window.location.pathname.startsWith("/en")) {
      localStorage.setItem("lang", "en");
      this.$i18n.locale = "en";
      return;
    }

    localStorage.setItem("lang", "zh-hk");
    this.$i18n.locale = "zh-hk";
  },

  mounted() {}

};